import { apiMiddleware } from 'redux-api-middleware';
import thunk from 'redux-thunk';

import myPageMiddleware from './config/middleware';
import myPageAuthMiddleware from './authentication/middleware';
import trackingMiddleware from './tracking/middleware';
import myPageSubscriptionMiddleware from './subscription/middleware';
import schibstedAccountMiddleware from './schibstedAccount/middleware';
/* PLOP_INJECT_MIDDLEWARE_IMPORT */

export default () => [
    thunk,
    apiMiddleware,
    schibstedAccountMiddleware,
    myPageMiddleware,
    myPageAuthMiddleware,
    trackingMiddleware,
    myPageSubscriptionMiddleware,
    /* PLOP_INJECT_MIDDLEWARE_EXPORT */
];
